import React from "react";
import { useHistory } from "react-router-dom";

import { AptihealthIcon } from "@/component-library/Icons/components/AptihealthIcon";
import { BhsIcon } from "@/component-library/Icons/components/BhsIcon";
import { CaseManagerIcon } from "@/component-library/Icons/components/CaseManagerIcon";
import { ICON_SIZES, ICON_TYPES } from "@/constants/icons";
import images from "@/utils/images";
import { IntakeIcon } from "@/component-library/Icons/components/IntakeIcon";
import { PcpIcon } from "@/component-library/Icons/components/PcpIcon";
import { PeerIcon } from "@/component-library/Icons/components/PeerIcon";
import { PrescriberIcon } from "@/component-library/Icons/components/PrescriberIcon";
import { useUnreadMessageCount } from "@/features/messaging/api/queries/useUnreadMessageCount";

import "../../styles.scss";

export function MessagesWidget({ profile, sendBirdContacts }) {
  const history = useHistory();
  const { data: messageCount = 0 } = useUnreadMessageCount();

  const renderNoMessages = () => {
    return (
      <div className="text-center mt-1 mx-4">
        <div className="fs-16 tw:font-bold">No Messages</div>
        <div className="fs-14">
          Messages will help you communicate with your care team throughout your aptihealth journey.
          New message notifications will appear here.
        </div>
      </div>
    );
  };

  const getCallIcon = (providerRole) => {
    switch (providerRole) {
      case "Behavioral Specialist":
        return (
          <BhsIcon className="IconWhite" iconSize={ICON_SIZES.LARGE} iconType={ICON_TYPES.CIRCLE} />
        );

      case "Case Manager":
        return (
          <CaseManagerIcon
            className="IconWhite"
            iconSize={ICON_SIZES.LARGE}
            iconType={ICON_TYPES.CIRCLE}
          />
        );

      case "Intake Behavioral Specialist":
        return (
          <IntakeIcon
            className="IconWhite"
            iconSize={ICON_SIZES.LARGE}
            iconType={ICON_TYPES.CIRCLE}
          />
        );

      case "PCP":
        return (
          <PcpIcon className="IconWhite" iconSize={ICON_SIZES.LARGE} iconType={ICON_TYPES.CIRCLE} />
        );

      case "Peer":
        return (
          <PeerIcon
            className="IconWhite"
            iconSize={ICON_SIZES.LARGE}
            iconType={ICON_TYPES.CIRCLE}
          />
        );

      case "Prescriber":
        return (
          <PrescriberIcon
            className="IconWhite"
            iconSize={ICON_SIZES.LARGE}
            iconType={ICON_TYPES.CIRCLE}
          />
        );

      default:
        return (
          <AptihealthIcon
            className="IconWhite"
            iconSize={ICON_SIZES.LARGE}
            iconType={ICON_TYPES.CIRCLE}
          />
        );
    }
  };

  const renderContacts = (careTeamMembers) => {
    return (
      <>
        {careTeamMembers
          .filter(
            (member) =>
              sendBirdContacts[member["provider_id"]] &&
              sendBirdContacts[member["provider_id"]]["shouldShow"],
          )
          .sort(
            (memberA, memberB) =>
              sendBirdContacts[memberB["provider_id"]]["unreadMessageCount"] -
              sendBirdContacts[memberA["provider_id"]]["unreadMessageCount"],
          )
          .slice(0, 2)
          .map((member) => {
            const unreadMessageCount =
              sendBirdContacts[member["provider_id"]]["unreadMessageCount"];

            return (
              <div className="py-2" key={`messages-widget-${member["provider_id"]}`}>
                <div
                  className="d-flex cursor"
                  onClick={() => history.push(`/app/messages?memberId=${member["provider_id"]}`)}
                  role="button"
                >
                  <div className="pr-lg-3 pr-2">{getCallIcon(member["type"])}</div>
                  <div className="fs-16 mt-2 widget-item-txt-wrapper tw:font-bold">
                    <div className="fs-16 widget-item-txt tw:font-bold">
                      <div className="d-inline-flex">
                        <div className="mt-2 tw:leading-3.75">{member.name}</div>
                        {unreadMessageCount > 0 && (
                          <span
                            className="fs-14 item-count item-count-ter mt-1"
                            style={{ margin: "2px 5px" }}
                          >
                            {unreadMessageCount}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </>
    );
  };

  return (
    <>
      <div className="dashboard-widget-card dashboard-widget-card-sm dashboard-widget-card-ter px-3 py-2 text-white tw:max-md:hidden">
        <div className="fs-lg-22 fs-20 mb-1 d-inline-flex tw:font-bold">
          <div className="mt-2 tw:leading-4.5">Your Messages</div>{" "}
          {messageCount > 0 && (
            <span className="fs-14 item-count item-count-ter">{messageCount}</span>
          )}
        </div>
        {sendBirdContacts && Object.keys(sendBirdContacts).length === 0 && renderNoMessages()}
        {sendBirdContacts &&
          Object.keys(sendBirdContacts).length > 0 &&
          renderContacts(profile.care_team_members)}
        {sendBirdContacts && Object.keys(sendBirdContacts).length > 2 && (
          <div
            className="widget-view-all d-flex fs-14 cursor Btn-xs-2 tw:font-bold"
            onClick={() => history.push("/app/messages")}
            role="button"
          >
            <img alt="+" src={images("./icons/common/view-all-white.svg")} />
            <div className="mt-1 ml-1">View All</div>
          </div>
        )}
      </div>
    </>
  );
}
